import { render, staticRenderFns } from "./ApplyAKSK.vue?vue&type=template&id=d480944e"
import script from "./ApplyAKSK.vue?vue&type=script&lang=js"
export * from "./ApplyAKSK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports